<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <span class="card-title">发展历程</span>
    </a-row>
    <a-form-model
      ref="ruleForm"
      :model="ruleForm">
      <a-form-model-item
        v-for="(item, index) in ruleForm.dataList"
        :key="index">
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="item.dateValue"
          @change="(date, dateString)=>onDateChange(date, dateString,item)"
        />
        --
        <a-input
          placeholder="请输入"
          v-model="item.content"
          :maxLength="20"
          style="max-width:200px; margin-right: 10px"/>
        <a-icon
          v-if="ruleForm.dataList.length > 1"
          :disabled="ruleForm.dataList.length === 1"
          type="minus-circle-o"
          @click="removeEvent(item)"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="dashed" style="width: 400px;" @click="addEvent">
          <a-icon type="plus"/>
          添加
        </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
        <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import moment from 'moment'

export default {
  name: 'DevelopmentHistory',
  mixins: [ruleFormMixins],
  data() {
    return {
      moment,
      ruleForm: {
        dataList: [{}]
      },
      rules: {},
      submitLoading: false
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      let url = 'pc/v2/development-history/query'
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          if (res && res.length > 0) {
            res.forEach(item => {
              item.dateValue = item.startDate ? moment(item.startDate, 'YYYY-MM-DD') : undefined
            })
          }
          this.getLogUtils().errorWithTag('dataList', res)
          this.ruleForm.dataList = res
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    onDateChange(date, dateString, item) {
      item.dateValue = date
      item.startDate = dateString
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        developHistorys: this.ruleForm.dataList
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/development-history/save', parms).then(res => {
        this.$message.success('保存成功')
        this.submitLoading = false
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    removeEvent(item) {
      let index = this.ruleForm.dataList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.dataList.splice(index, 1)
      }
    },
    addEvent() {
      this.ruleForm.dataList.push({
        content: '',
        startDate: ''
      })
    }
  }
}
</script>

<style lang="less">
.ant-upload-picture-card-wrapper {
  width: 140px;
}

.selected-image {
  width: 116px;
  height: 40px;
}

.color-list {
  display: flex;

  .color-box {
    width: 70px;
    height: 30px;
    border-radius: 5px;
    margin: 5px 20px 5px 0;
  }
}

.selected-box {
  box-sizing: border-box;
  border: 2px solid rgba(0, 0, 0, 0.3);
}
</style>